/* SUPPORTA — lightweight storefront enhancements.
   Kept dependency free and deferred: no layout shift, no blocking work. */
(function () {
  'use strict';

  /* ---------------------------------------------------------------------
     Reveal on scroll (respects prefers-reduced-motion via CSS)
     --------------------------------------------------------------------- */
  function initReveal() {
    var nodes = document.querySelectorAll('.sa-reveal:not([data-in])');
    if (!nodes.length) return;

    if (!('IntersectionObserver' in window)) {
      nodes.forEach(function (n) { n.setAttribute('data-in', 'true'); });
      return;
    }

    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.setAttribute('data-in', 'true');
          io.unobserve(entry.target);
        });
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0.05 }
    );

    nodes.forEach(function (n) { io.observe(n); });
  }

  /* ---------------------------------------------------------------------
     Sticky add-to-cart bar on product pages.
     Shows once the real buy buttons have scrolled out of view, and simply
     forwards the click to the theme's own add-to-cart button so variant
     selection, inventory rules and the cart drawer all keep working.
     --------------------------------------------------------------------- */
  function initStickyAtc() {
    var bar = document.querySelector('[data-sa-sticky]');
    if (!bar) return;

    var form = document.querySelector('product-form-component form, form[action*="/cart/add"]');
    var realButton = form ? form.querySelector('[type="submit"], .add-to-cart-button, button.button') : null;
    var anchor = realButton || form;

    if (!anchor) {
      bar.remove();
      return;
    }

    var trigger = bar.querySelector('[data-sa-sticky-button]');
    if (trigger) {
      trigger.addEventListener('click', function (event) {
        event.preventDefault();
        if (realButton && !realButton.disabled) {
          realButton.click();
        } else if (form) {
          form.requestSubmit ? form.requestSubmit() : form.submit();
        }
      });
    }

    function setVisible(visible) {
      bar.setAttribute('data-visible', visible ? 'true' : 'false');
    }

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            setVisible(!entry.isIntersecting && entry.boundingClientRect.top < 0);
          });
        },
        { threshold: 0 }
      );
      io.observe(anchor);
    } else {
      window.addEventListener(
        'scroll',
        function () {
          var rect = anchor.getBoundingClientRect();
          setVisible(rect.bottom < 0);
        },
        { passive: true }
      );
    }

    /* Keep the sticky price in sync with the selected variant. */
    var priceTarget = bar.querySelector('[data-sa-sticky-price]');
    if (priceTarget) {
      var source = document.querySelector('.product-details .price, product-price, .price');
      if (source && 'MutationObserver' in window) {
        var mo = new MutationObserver(function () {
          var text = source.textContent.trim().replace(/\s+/g, ' ');
          if (text) priceTarget.textContent = text;
        });
        mo.observe(source, { childList: true, subtree: true, characterData: true });
      }
    }
  }

  function boot() {
    initReveal();
    initStickyAtc();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  /* Re-run inside the theme editor when a section is re-rendered. */
  document.addEventListener('shopify:section:load', boot);
})();
